const Strings = {
  TO_SIGN_IN: {
    SE: 'Till logga in',
    EN: 'To sign in'
  },
  ASSOCIATION_NAME: {
    SE: 'Föreningsnamn*',
    EN: 'Association name*'
  },
  PHONE_NUMBER: {
    SE: 'Telefonnummer*',
    EN: 'Phone number*'
  },
  EMAIL: {
    SE: 'Email*',
    EN: 'Email*'
  },
  PASSWORD: {
    SE: 'Lösenord*',
    EN: 'Password*'
  },
  GET_STARTED: {
    SE: 'Kom igång',
    EN: 'Get started'
  },
  GET_STARTED_INFO: {
    SE:
      'Du binder inte upp dig eller din förening till någonting genom att komma igång. Ni börjar aldrig betala innan vi har varit i kontakt med er och ni känner er nöjda.',
    EN:
      'You do not tie down you or your association to anything by getting started. You never start paying before we have been in contact and you are satisfied.'
  },
  TO_WEB_PAGE: {
    SE: 'Tillbaka till hemsidan',
    EN: 'Back to the web page'
  },
  MANDATORY_FIELDS: {
    SE: 'Fyll i alla obligatoriska fält',
    EN: 'Enter all mandatory fields'
  },
  MANDATORY_FIELDS_INFO: {
    SE: 'Var god fyll i alla obligatoriska fält och försök igen.',
    EN: 'Please enter all the mandatory fields and try again.'
  },
  OK: {
    SE: 'Okej',
    EN: 'Okey'
  },
  EMAILS_DONT_MATCH: {
    SE: 'Emailadresserna matchar ej',
    EN: 'The email addresses does not match'
  },
  EMAILS_DONT_MATCH_INFO: {
    SE: 'Emailadresserna matchar ej, var god försök igen.',
    EN: 'The email addresses does not match, please try again.'
  },
  PASSWORDS_DONT_MATCH: {
    SE: 'Lösenorden matchar ej',
    EN: 'The passwords does not match'
  },
  PASSWORDS_DONT_MATCH_INFO: {
    SE: 'Lösenorden matchar ej, var god försök igen.',
    EN: 'The passwords does not match, please try again.'
  },
  NOT_VALID_EMAIL: {
    SE: 'Emailadressen är ej giltlig',
    EN: 'The email address is not valid'
  },
  NOT_VALID_EMAIL_INFO: {
    SE: 'Emailadressen är ej giltlig, var god försök igen.',
    EN: 'The email address is not valid, please try again.'
  },
  NEXT: {
    SE: 'Nästa',
    EN: 'Next'
  },
  BACK: {
    SE: 'Tillbaka',
    EN: 'Back'
  },
  WHAT_SYSTEMS_TO_ACTIVATE: {
    SE: 'Vilka system vill ni aktivera?',
    EN: 'What systems do you wish to activate?'
  },
  LAUNDRY_BOOKING_SYSTEM: {
    SE: 'Tvättbokningssystem',
    EN: 'Laundry booking system'
  },
  OTHER_BOOKING_SYSTEM: {
    SE: 'Andra bokningssystem (t.ex. bastu)',
    EN: 'Other booking systems (ex. sauna)'
  },
  ERROR_REPORT_SYSTEM: {
    SE: 'Felanmälan',
    EN: 'Error report system'
  },
  NEWS_FEED: {
    SE: 'Nyhetsflöde',
    EN: 'News feed'
  },
  INFO_VIEW: {
    SE: 'Infovy',
    EN: 'Info board'
  },
  EMAIL_TAKEN: {
    SE: 'Email adressen är redan i bruk',
    EN: 'The email is already in use'
  },
  CHOSE_ATLEAST_ONE_SYSTEM: {
    SE: 'Välj system',
    EN: 'Select system'
  },
  CHOSE_ATLEAST_ONE_SYSTEM_INFO: {
    SE: 'Välj minst ett system som ni vill använda i er förening.',
    EN: 'Select atleast one system that you wish to use in your association.'
  }
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/pages/preLogin/GetStarted/strings.js